import { themeOptions } from 'constants/constants';
import themeEuOldUI from 'styles/theme/eu';
import themeEuNewUI from 'styles/theme/euNew';

export const FindTheme = (code: string, isNewDesign: boolean) => {
  var theme = themeOptions.find((x) => x.code.toLowerCase() === code.toLowerCase())?.themes;
  return isNewDesign ? theme?.new ?? themeEuNewUI : theme?.old ?? themeEuOldUI;
};
